import React from 'react';

import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => (
  <div className="app__aboutus app__bg flex__center section__padding" id="about">
    <div className="app__aboutus-overlay flex__center">
      <img src={images.G} alt="G_overlay" />
    </div>

    <div className="app__aboutus-content flex__center">
      <div className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">About Us</h1>
        <img src={images.spoon} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans"> We are a non-partisan entity that consists of great thinkers who tirelessly work to produce timeless treatise which illuminate the purpose of each earthling.</p>
        {/*<button type="button" className="custom__button">Know More</button>*/}

       

      </div>

      <div className="app__aboutus-content_knife flex__center">
        <img src={images.knife} alt="about_knife" />
      </div>

      <div className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Remedials</h1>
        <img src={images.spoon} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans">We extend our services beyond just literary work, engaging the public by outreach charity works, mental health awareness initiatives and public intellectual educational events. This is a way of giving back to the society, regardless of the gender orientation,ethnic extraction or geographical location.</p>
        {/*<button type="button" className="custom__button">Know More</button>*/}
      </div>
    </div>
  </div>
);

export default AboutUs;